// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
  ##Device = Desktops
  ##Screen = 1281px to higher resolution desktops
*/
@media (max-width: 991px) {
  .not-top-icon {
    top: 23px;
  }

  .bg-video {
    display: none;
  }
  .home-sec-testimonial .home-slider-next {
    display: none;
  }
  .home-sec-testimonial .home-slider-prev {
    display: none;
  }
  .mobile-nav {
    display: block;
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #000;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    transform: translateX(100%);
    transition: transform 0.5s linear;
    padding: 20px;
  }

  .mobile-nav .one {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mobile-nav .two {
    margin-top: 36px;
    height: calc(100vh - 93.64px);
    display: flex;
    justify-content: center;
    align-items: start;
  }

  .mobile-nav .one .one-right svg {
    font-size: 30px;
    color: #fff;
    cursor: pointer;
  }

  .mobile-nav .two ul li {
    text-align: center;
    font-size: 20px;
    color: #f6f6f6;
    font-weight: 500;
    margin-bottom: 0px;
    margin-top: 20px;
  }

  .simple-btn.login {
    display: none;
  }

  header .header-wrap .left {
    width: 100%;
  }

  header .header-wrap {
    padding-inline: 20px;
  }

  .hamburger-mobile {
    display: block;
  }

  .hamburger-mobile ul {
    margin: 0;
    padding: 0;
  }

  .hamburger-mobile ul li svg {
    font-size: 28px;
    color: #e11f1c;
  }

  header .header-wrap .center {
    display: none;
  }

  .language-btn {
    display: none;
  }

  .lp-btn {
    /* display: none !important; */
  }
  .lp-btnn {
    display: none !important;
  }

  /* For logout button responsive on tablet and mobiles */
  .profile-card .admin-profile-logout {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .lp-news-btn {
    display: none;
  }

  .join-banner-news {
    display: flex;
    flex-direction: column;
  }

  .join-banner-news {
    padding: 5px;
  }
  .join-banner-news img {
    width: 200px;
    object-fit: contain;
  }
  .mobile-nav {
    display: block;
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: #3e3e3e;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    transform: translateX(100%);
    transition: transform 0.5s linear;
    padding: 30px;
  }
  .data-0twelve {
    display: block;
  }
  .home-sec-testimonial {
    padding-inline: 12px;
    overflow-x: hidden;
  }
  .home-sec-testimonial {
    padding: 60px 0px;
  }
  .home-sec-testimonial .slick-prev {
    left: -45px;
  }
  .home-sec-testimonial .slick-next {
    right: -45px;
  }
  .storeSection .InvestCardCon {
    grid-template-columns: repeat(2, 1fr);
  }
  .storeSectionDetail .top {
    flex-direction: column;
    align-items: start;
    padding-inline: 10px;
  }
  .storeSectionDetail .bottom .container {
    flex-direction: column-reverse;
    align-items: start;
    margin: 0;
    width: 100%;
    max-width: none;
    margin-bottom: 30px;
  }
  .storeSectionDetail .bottom .container .right {
    width: 100%;
  }
  .storeSectionDetail .top-heading {
    margin-top: 40px;
  }
  .storeSectionDetail .top .left {
    width: 100%;
    padding-right: 50px;
  }
  .storeSectionDetail .top .right {
    width: 100%;
    padding-right: 50px;
  }
}

@media (max-width: 768px) {
  .offer-modal-sec .offer-modal-img img {
    width: 134px;
  }

  .offer-modal-img .text p {
    font-size: 9px;
    width: 95px;
    line-height: 15px;
  }
  .offer-modal-img .text p span {
    font-size: 10px !important;
  }
  .storeSectionDetail .swiper-slide .type-img {
    height: 250px;
  }
  .storeSectionDetail .swiper-slide .wrap-video .background img:nth-child(1) {
    height: 250px;
  }
  .storeSectionDetail .bottom .container .left h1 {
    font-size: 40px;
    line-height: 40px;
  }
  .storeSectionDetail .top-heading p {
    text-align: start;
  }
  .storeSectionDetail .top .right {
    padding-right: 0;
  }
  .storeSection .InvestCardCon .InvestCard .top {
    height: auto;
  }
  .css-2u6ojp-MuiContainer-root {
    padding: 0px 12px;
  }
  .storeSection .content .heading {
    font-size: 60px;
    line-height: 68px;
  }
  .storeSection .content .sub-heading {
    font-size: 18px;
    line-height: 24px;
  }

  .storeSection .InvestCardCon {
    grid-template-columns: repeat(1, 1fr);
  }
  .storeSection .search-con {
    flex-direction: column;
  }
  .storeSection .search-con .left {
    border: none;
    padding-inline: 6px;
  }
  .storeSection .search-con .left input {
    /* padding: 8px 40px; */
    line-height: 20px;
    padding-inline-start: 40px;
  }
  .storeSection .search-con .left .wrap .search-icon {
    width: 30px;
    left: 20px;
  }
  .storeSection .InvestCardCon .InvestCard .bottom {
    padding: 16px;
  }
  .storeSection .search-con .right {
    width: 100%;
    padding-inline: 6px;
  }
  .storeSection .search-con .right .store-select-wrapper {
    width: 100% !important;
  }
  .storeSectionDetail .top-heading h1 {
    font-size: 50px;
    line-height: 52px;
  }
  .storeSectionDetail .bottom .main-heading {
    margin-bottom: 50px;
  }
  .home-sec-1 .home-sec-1-left h1 span {
    color: #fff;
  }
  .home-sec-1 {
    margin-top: 0px !important;
  }

  header .header-wrap {
    padding-inline: 20px;
  }

  .sec-four .sec10-container .sec10-list .sec10-title {
    gap: 20px;
  }
  .home-sec-three p {
    text-align: center;
  }
}

@media (max-width: 768px) {
  .checkout-field-referral-box {
    justify-content: center !important;
  }
  .home-sec-testimonial {
    padding: 40px 0px;
  }
  .card-1,
  .card-2 {
    width: 380px;
    height: 480px;
  }

  .signature-sec {
    margin-top: 20px;
    padding: 0px;
  }

  .signature-sec .top .top-1 {
    flex-direction: row !important;
  }

  .top .top-2 #convas {
    width: 95%;
  }
  .css-2u6ojp-MuiContainer-root {
    width: calc(100% - 78px) !important;
    padding: 0;
  }
}

@media (max-width: 768px) {
  .css-vj1n65-MuiGrid-root{
    width: 100%;
  }
  .MuiGrid-root.MuiGrid-container.css-11lq3yg-MuiGrid-root{
    flex-wrap: nowrap !important;
  }
  .container-withdrawl {
    flex-direction: column;
    align-items: center;
    flex-direction: column-reverse;
    /* margin: 20px; */
  }
  .mainContainerComp .form-control{
    padding-inline-start: 12px;
  }
  .mainContainerComp .form-select{
    padding-inline-start: 12px;
  }
  .css-1jt94r9-MuiGrid-root{
    width: 100% !important;
  }

  .balance-withdrawl {
    font-size: 20px !important;
  }

  .doc-with-title .doc-title {
    font-family: "Bebas Neue";
    font-size: 35px;
    font-weight: 700;
    line-height: 35px;
    letter-spacing: 0em;
    text-align: left;
  }

  .doc-with-title {
    padding-left: 0px;
  }
  .css-2u6ojp-MuiContainer-root {
    width: 100%;
  }

  .other-details {
    display: flex;
    padding-left: 0px;
    flex-direction: column;
  }

  .other-details h4 {
    margin-top: 10px;
    font-size: 22px;
    font-weight: 600;
    line-height: 26px;
  }

  .other-details p {
    font-family: "Raleway";
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .doc-card {
    margin: 20px 0px;
    height: 350px;
  }

  .home-sec-ten {
    padding: 40px 0;
  }
  .dashboard-box {
    flex-direction: column;
    height: auto;
    gap: 20px;
  }
  .dashboard-box h3 {
    text-align: center;
  }
  .dashboard-box h4 {
    text-align: center;
  }
  .dashboard-box h6 {
    text-align: center;
  }
}

@media (max-width: 500px) {
  .dashboard-box img {
    margin-bottom: 10px;
  }
  .css-1p16mnu {
    padding-top: 39px;
  }
  .storeSectionDetail .top-heading h1 {
    font-size: 30px;
    line-height: 38px;
  }
  .storeSectionDetail .bottom .main-heading {
    font-size: 40px;
    line-height: 48px;
  }
  .storeSectionDetail .bottom {
    margin-bottom: 40px;
  }
  .storeSectionDetail .bottom .container .left h1 {
    font-size: 40px;
    line-height: 40px;
  }
}
@media (max-width: 420px) {
  /* .modal-dialog-centered{
    margin-top: 20px !important;
    } */
  .css-hyum1k-MuiToolbar-root {
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: 15px;
  }
  .simple-square-btn {
    /* padding: 5px 8px; */
  }
}
@media (max-width: 400px) {
  .storeSection .InvestCardCon .InvestCard .bottom .box1 {
    flex-direction: column;
    align-items: start;
  }
  .storeSection .InvestCardCon .InvestCard .bottom .box2 {
    flex-direction: column;
    align-items: start;
  }
}

@media (min-width: 320px) and (max-width: 500px) {
  .card-1,
  .card-2 {
    width: 350px;
    height: 480px;
  }

  .layout_currency-text {
    font-size: 15px;
  }

  .primary-btn-profit {
    font-size: 17px !important;
    padding: 10px 13px;
    border-radius: 10px;
  }
  .css-tzsjye {
    margin-top: 30px !important;
    width: 100% !important;
  }
  .css-i6s8oy {
    display: block !important;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .sec-five .layout-text-profit {
    align-items: center;
  }

  .card-1,
  .card-2 {
    width: 360px;
    height: 500px;
  }

  .layout_currency-text {
    font-size: 15px;
  }

  .primary-btn-profit {
    font-size: 17px;
  }
}

@media (max-width: 320px) {
  .card-1,
  .card-2 {
    width: 300px;
    height: 500px;
  }

  .card-1 {
    padding-top: 2rem;
    padding-left: 0.4rem;
  }

  .layout_currency-text {
    font-size: 12px;
    padding: 12px;
  }

  .primary-btn-profit {
    font-size: 13px !important;
    padding: 10px 13px;
    border-radius: 10px;
  }
}

@media (min-width: 1020px) {
  /* CSS */
  .header-button {
    display: none;
  }

  .not-button {
    display: none;
  }

  .mobile-header {
    display: none;
  }
}

/* 
    ##Device = Laptops, Desktops
    ##Screen = B/w 1025px to 1280px
  */

@media (min-width: 1024px) and (max-width: 1280px) {
  /* CSS */
  .header-body li a {
    padding: 0 0.7rem !important;
    font-size: 10px !important;
  }

  .custom-header .btn {
    font-size: 12px !important;
  }

  .custom-card {
    width: 260px;
  }

  .banner-text {
    font-size: 70px;
  }

  .team-img-1 {
    width: 100%;
  }

  .team-img-2 {
    height: 100%;
  }

  .invest-second .invest-search-input input {
    width: 460px;
  }

  .investment-section h2 {
    font-size: 60px;
  }

  .section2 .img img {
    width: 65%;
  }
}

/* 
    ##Device = Tablets, Ipads (portrait)
    ##Screen = B/w 768px to 1024px
  */

@media (min-width: 768px) and (max-width: 1024px) {
  .custom-card {
    width: 100%;
  }

  .custom-card-two {
    width: 100%;
  }

  .main-header
    .language-btn:not(.mobile-header .language-btn)
    .pitch-card-wrapper {
    margin-top: 4.8rem;
  }
}

/* 
    ##Device = Tablets, Ipads (landscape)
    ##Screen = B/w 768px to 1024px
  */

@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  /* CSS */
}

/* 
    ##Device = Low Resolution Tablets, Mobiles (Landscape)
    ##Screen = B/w 481px to 767px
  */

@media (min-width: 481px) and (max-width: 768px) {
  /* CSS */
}

/* 
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
  */

/* Tablets */
@media (max-width: 991px) {
  .home-sec-twelve .data {
    display: none;
  }

  .data-0twelve {
  }

  .data-0twelve h1 {
    font-size: 35px;
    font-weight: 800;
    line-height: 45.57px;
    text-align: center;
    color: #252525;
    margin-bottom: 12px;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .data-0twelve h1 span {
    color: #e11f1c;
  }

  .data-0twelve .cardd {
    padding: 20px;
    border: 2px solid #252525;
    border-radius: 12px;
    margin-bottom: 20px;
  }

  .data-0twelve .cardd h1 {
    font-size: 35px;
    font-weight: 800;
    line-height: 45.57px;
    text-align: center;
    color: #e11f1c;
    margin-bottom: 12px;
  }
  .data-0twelve .cardd h3 {
    font-size: 16px;
    font-weight: 700;
    line-height: 25.6px;
    text-align: center;
    color: #252525;
    margin-bottom: 10px;
  }

  .data-0twelve .cardd p {
    font-size: 16px;
    font-weight: 400;
    line-height: 25.6px;
    text-align: center;
    color: #252525;
  }

  .home-sec-twelve {
    height: auto;
  }

  .data-0twelve .button {
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .data-0twelve .button button {
    border-radius: 5px;
    padding: 15px 25px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff;
    background-color: #252525;
    border: none;
  }

  .home-sec-twelve {
    margin: 0;
  }

  .home-sec-twelve .bg-video,
  .home-sec-twelve .content,
  .home-sec-twelve .content-card {
    position: static;
  }

  .sec-four h2 {
    width: 100%;
  }

  .home-sec-seven h3 {
    width: 100%;
  }

  .home-sec-six .home-sec-six-right img {
    margin-top: 30px;
  }

  header {
    background-color: #fff;
  }

  .home-sec-five .left .home-sec-five-left-two,
  .home-sec-five .left .home-sec-five-left-three {
    margin-right: 0px;
    margin-left: 0px;
  }

  .home-sec-five .home-sec-five-center img {
    width: 100%;
    margin: 30px 0px;
  }

  .home-sec-five .right .home-sec-five-right-two,
  .home-sec-five .right .home-sec-five-right-three {
    margin-left: 0px;
    margin-right: 0px;
  }

  .home-sec-five h3 {
    font-size: 35px;
    font-weight: 800;
    line-height: 45.57px;
    text-align: center;
    color: #252525;
    margin-bottom: 20px;
    width: 100%;
    margin-inline: auto;
  }

  .home-sec-1 {
    padding: 130px 0px;
    background-position: right;
    margin-top: 200px;
  }
  .close-icon-sec7 {
    position: absolute;
    top: -10px;
    right: 44px;
  }

  .home-sec-1 .home-sec-1-left h1 {
    font-size: 42px;
    font-weight: 400;
    line-height: 52.63px;
    text-align: left;
    margin-bottom: 20px !important;
  }

  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(2) {
    background-color: transparent;
  }

  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(1)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(3)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(4)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(6)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(7)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(9)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(10)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(12)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(13)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(15)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(16)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(18)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(19)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(21)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(22)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(24)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(25)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(27)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(28)
    div
    .person-item-wrapper {
    background: #fff;
    border: 2px solid #fff;
    border-radius: 16px;
    padding: 23px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    margin: 10px;
    position: relative;
    top: 0px;
  }

  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(2)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(5)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(8)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(11)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(14)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(17)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(20)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(23)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(26)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(29)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(32)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(35)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(38)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(41)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(44)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(47)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(50)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(53)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(56)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(59)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(62)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(65)
    div
    .person-item-wrapper,
  .home-sec-two
    .slick-slider
    .slick-list
    .slick-track
    .slick-slide:nth-child(68)
    div
    .person-item-wrapper {
    background: #252525;
    border: 2px solid #fff;
    border-radius: 16px;
    padding: 23px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    margin: 10px 10px 10px 10px;
  }

  .home-sec-two {
    padding-inline: 139px;
    margin-top: -110px;
  }

  .home-sec-1 .home-sec-1-left .button button:nth-child(2) {
    padding: 15px 25px;
    color: #252525;
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #fff;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 600;
    line-height: 20.83px;
    text-align: left;
  }

  .home-sec-1 .home-sec-1-left p {
    font-size: 16px;
    font-weight: 600;
    line-height: 25.6px;
    text-align: left;
    /* color: #252525; */
    margin-bottom: 25px !important;
  }

  .home-sec-three .home-sec-three-left img {
    margin-bottom: 30px;
  }

  .home-sec-four .home-sec-four-right img {
    margin-top: 30px;
  }

  .home-sec-twelve,
  .home-sec-eleven,
  .home-sec-ten,
  .home-sec-eight,
  .home-sec-seven,
  .home-sec-six,
  .home-sec-five,
  .home-sec-four,
  .home-sec-three,
  .home-sec-two,
  .home-sec-one {
    padding: 60px 0px;
  }

  .home-sec-eleven .right {
    margin-top: 30px;
  }

  .mobile-nav .two ul {
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-nav .two ul {
  }

  .language-btnn {
    margin-top: 30px;
    margin-inline: 0px;
  }

  /* header  */
  .line-red {
    display: none;
  }

  .hide-on-responsive {
    display: none;
  }

  .padding-from-left-for-chart_1 {
    padding-left: 7%;
  }

  .padding-from-left-for-chart {
    padding-left: 5%;
  }

  .header-main {
    position: fixed;
    top: 0;
    right: 0;
    background: var(--white);
    height: 100%;
    z-index: 1;
    overflow: auto;
  }

  .header-hide {
    width: 0px;
    transition: all 0.4s ease-in-out;
  }

  .mobile-hide {
    display: none !important;
  }

  .mobile-show {
    display: block !important;
  }

  .header-show {
    width: 300px;
    transition: all 0.4s ease-in-out;
  }

  .header-main .header-body {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .header-body li {
    padding: 0 0.5rem;
  }

  .mobile-header-top {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0;
    margin: 0 1rem;
    margin-bottom: 1rem !important;
    border-bottom: 1px solid;
    border-color: var(--primary);
  }

  .mobile-header-top img {
    width: 100px;
  }

  .mobile-header-top .cross-icon {
    color: black;
  }

  .header-bottom {
    display: block !important;
    padding: 1rem 1.5rem;
  }

  /* header end  */

  .team-img-1 {
    height: 100%;
    width: 100%;
  }

  .team-img-2 {
    height: 100%;
  }

  .card-lg {
    width: 100% !important;
    padding: 0 0.9rem;
  }

  /* .custom-card-two {
  } */
  .banner-text {
    font-size: 50px;
  }

  .common-heading {
    margin-bottom: 30px;
  }

  .invest-second .invest-search-input input {
    width: 450px;
  }

  .investment-section h2 {
    font-size: 40px;
  }

  .investment-section h4 {
    font-size: 18px;
  }

  .col-without-padding {
    display: flex;
  }

  .col-without-padding .about-card-order-1 {
    order: 1;
  }

  .col-without-padding .about-card-order-2 {
    order: 2;
  }

  .col-without-padding .about-card-order-3 {
    order: 3;
  }

  .col-without-padding .about-card-order-3 img {
    width: 100%;
  }

  .col-without-padding .about-card-order-4 {
    order: 4;
  }

  .items img {
    width: 200px;
  }

  .items .title-section {
    justify-content: space-between;
  }

  .chevron-icon {
    display: inline-flex !important;
  }

  #investment-simulation .image img {
    width: 50%;
  }

  .investment-second h2 {
    font-size: 40px;
  }

  #investment-simulation .bg-image .content h3 {
    margin: 0px;
    font-size: 18px;
  }

  .section2 .img img {
    width: 50%;
  }

  #section-bg-atteched .background-text .common-heading {
    font-size: 26px;
  }
}

@media (min-width: 991px) {
  .sidebar {
    position: relative !important;
  }

  .sidebar.open {
    width: 300px !important;
  }

  .dashboard-section-main {
    margin-left: 0px !important;
  }
}

/* Tablets */
@media (max-width: 767px) {
  .home-sec-twelve,
  .home-sec-eleven,
  .home-sec-ten,
  .home-sec-eight,
  .home-sec-seven,
  .home-sec-six,
  .home-sec-five,
  .home-sec-four,
  .home-sec-three,
  .home-sec-two,
  .home-sec-one {
    padding: 30px 0px;
  }

  .sec-five .card-11,
  .sec-five .card-22 {
    padding: 30px;
  }

  .home-sec-seven .video {
    position: relative;
    height: 299px;
  }

  .home-sec-seven .video .right-img,
  .home-sec-seven .video .left-img {
    display: none;
  }

  .home-sec-seven .video .background {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
  }

  .items .title-section {
    justify-content: space-between;
  }

  .items .title-section h3 {
    margin: 0;
    font-size: 18px;
  }

  .items p {
    font-size: 16px;
    margin-top: 1rem;
  }

  .items img {
    width: 150px;
  }

  .invest-second .invest-search-input input {
    width: 95%;
  }

  .investment-second {
    margin-top: 50px;
    text-align: center;
  }

  .investment-second h3 {
    font-size: 24px;
  }

  .investment-second h2 {
    font-size: 35px;
  }

  .invest-second img {
    width: 70%;
  }

  .investment-second p {
    font-size: 16px;
  }

  .join-section .custom-input {
    width: 375px !important;
  }

  .blog-body h3 {
    font-size: 22px;
  }

  .target-img img {
    margin: auto;
  }

  .section-title {
    font-size: 25px;
  }

  .main-container-new .content h1 {
    font-family: "Poppins";
    font-size: 36px;
    font-weight: 700;
    line-height: 48px;
    letter-spacing: 0em;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    width: 100%;
    margin-inline: auto;
    padding-top: 60px;
  }
}

/* Extra Small Devices, Phones */
@media (max-width: 480px) {
  .contact-image {
    width: 100%;
  }

  .checkout-terms {
    font-size: 1rem;
    font-weight: 400;
  }

  .section2 .img img {
    width: 100%;
  }

  #investment-simulation .bg-image .content h3 {
    margin: 0px;
    font-size: 12px;
  }

  #section-bg-atteched .background-text .common-heading {
    font-size: 20px;
  }

  .items .title-section .first {
    width: 75%;
  }

  .banner-text {
    font-size: 22px;
  }

  .home-banner {
    font-size: 35px;
  }

  .banner-inner {
    height: 500px;
  }

  .logo-section img {
    width: 60% !important;
  }

  .section-title {
    font-size: 14px !important;
  }
}

@media (min-width: 320px) and (max-width: 480px) {
  /* CSS */
  .join-section .custom-input {
    width: 200px !important;
    margin-right: 1.5rem !important;
  }
}

@media (max-width: 425px) {
  .main-search {
    display: flex !important;
    flex-wrap: wrap;
  }

  .main-search .invest-search-input {
    order: 1;
    flex-basis: 100%;
    margin-bottom: 25px;
  }

  .main-search .invest-drop-down {
    order: 2;
    flex-basis: 47%;
  }

  .main-search .search-btn {
    order: 3;
    flex-basis: 47%;
  }

  .main-search .css-pe0pe4-MuiFormControl-root {
    width: 100%;
  }

  .main-search .search-btn .btn {
    width: 100% !important;
  }

  .custom-card img {
    width: 95%;
  }

  .custom-card .tag {
    top: -35px;
    right: 0px;
  }
}

@media screen and (max-width: 1049px) {
  .section-title {
    font-size: 35px;
  }

  .bg-video-landing {
    width: auto;
  }

  .main-container {
    padding-top: 3rem;
  }

  .grid-section2 .large-p,
  .accordion-button {
    font-size: 20px;
  }

  .normal-p,
  .accordion-body {
    font-size: 16px !important;
  }
}

@media screen and (min-width: 768px) {
  /* .header-button,
  .mobile-header {
    display: none !important;
  } */
}

@media screen and (max-width: 1020px) {
  .main-header .button-group {
    display: none;
  }

  /* .header-button,
  .mobile-header {
    display: none !important;
  } */
}

@media screen and (max-width: 768px) {
  .sec-two .text-start p {
    font-size: 20px;
    line-height: 32px;
  }

  .normal-p,
  .normal-p * {
    font-size: 16px;
  }

  .mobile-col-reverse {
    flex-direction: column-reverse;
  }

  .main-header .language-btn:not(.mobile-header .language-btn) {
    display: none;
  }

  .rounded-input-group {
    width: 100%;
  }

  .mobile-header .language-btn {
    display: flex;
    justify-content: center;
    margin: 0;
  }

  .main-header-link,
  .main-header .lp-btn:not(.mobile-header .lp-btn) {
    display: none;
  }

  .col-mobile-reverse {
    flex-direction: column-reverse;
  }

  .main-section .row p {
    padding: 0 !important;
  }

  .main-logo {
    width: 50px;
    height: auto;
  }

  /* a.main-header-link {
    display: none;
  } */

  .header-line {
    height: 24px;
  }

  .main-header button {
    font-size: 0.9rem;
  }

  .main-header-link {
    font-size: 0.9rem;
  }

  .main-section {
    /* padding-bottom: 3em; */
  }

  .main-section-text {
    padding-right: 0;
  }

  .custom-section.get-started-section {
    padding: 3rem 0;
  }

  .get-started-body {
    width: 100%;
  }

  .stat-box {
    padding: 0.7em;
  }

  .stat-number {
    font-size: 2.5vw;
  }

  .stat-icon {
    width: 30px;
  }

  .stat-label {
    font-size: 2.5vw;
  }

  .section-title {
    font-size: 25px;
    margin-bottom: 1em;
  }

  .accordion-section {
    padding-bottom: 0;
  }

  .normal-p,
  .accordion-body {
    font-size: 14px !important;
  }

  .sidebar:not(.open) {
    width: 60px !important;
    left: 0px !important;
  }

  .dashboard-section-main {
    margin-left: 60px !important;
  }

  .main-section {
    /* margin-left: 60px !important; */
  }

  .sidebar .logo-details #btn {
    right: 0 !important;
  }

  .main-section .row {
    justify-content: center;
  }

  .open-sidebar .button-group {
    transform: translateX(180px);
  }

  .sidebar.open {
    /* padding-left: 2em; */
  }

  footer .footer-social .common-heading {
    margin-bottom: 5px;
  }

  .lp-shop-crop {
    width: 100%;
    transform: none;
  }

  .landing-page .main-section-text {
    justify-content: flex-end !important;
  }

  .main-section-text p {
    padding: 0 1rem;
  }

  .main-section-text p:first-child {
    padding-bottom: 0.7em;
  }

  .pure-section-text {
    width: 100%;
    text-align: justify;
    text-align-last: center;
  }

  .custom-section.pure-section {
    padding: 4rem 2rem;
  }
  .custom-box {
    padding: 16px;
    margin: 4px;
  }
  .card-bg-img {
    display: none;
  }
  .custom-header .logo-section {
    padding-inline-start: 10px;
  }
  .header-body {
    gap: 8px !important;
  }
  .wallet-cardd {
    grid-template-columns: repeat(2, 1fr);
  }
  .mainContainerComp {
    padding: 16px !important;
  }
  .userContainer {
    padding: 16px  !important;
  }
  .mainContainerComp .send-notification-btn{
    min-width: 0px;
  }
}

@media (max-width: 500px) {
  /* .dashboard-logo {
    display: none;
  } */

  .wallet-cardd {
    grid-template-columns: repeat(1, 1fr);
  }
  .dashboard-section-main {
    /* padding-left: 1em !important; */
  }
  .dashboard-box h4 {
    text-align: center;
  }

  .dashboard-section-main .MuiContainer-root {
    padding-left: 0;
    padding-right: 4px;
  }

  .stat-box {
    padding: 0.5em;
  }

  .stat-number {
    font-size: 3.5vw;
  }

  .stat-label {
    font-size: 3vw !important;
  }

  .stat-box.order-1 {
    transform: translateX(50%);
  }

  .stat-box.order-2 {
    transform: translateX(50%);
  }

  .stat-box.order-5 {
    transform: translateX(50%);
  }

  .custom-header {
    padding: 1rem 0 !important;
  }
}

@media (max-width: 768px) {
  .Heading-row-t2 {
    display: none;
  }

  .Table-of-content-inner {
    flex: 100% 1;
    /* Both tables take 100% width on mobile view */
  }

  .primary-tab {
    font-size: 1rem;
  }

  .Content-main-heading-1 {
    font-size: 45px;
  }
}

@media (max-width: 767px) {
  .New-login-form-Content {
    flex: 100% 1;
  }

  .join-banner-news {
    padding: 5px;
  }

  .New-login-form-form {
    min-width: 300px;
    margin: 20px auto !important;
  }

  .New-login-form-main {
    height: auto;
  }

  .New-login-form-inside {
    margin: 0 10px;
  }

  .Form-checkbox-holder,
  .forget-password-btn {
    font-size: 12px;
  }

  .Content-Main-Heading-container {
    margin: 2% 5%;
    height: 120px;
  }

  .Content-main-heading-1 {
    font-size: 32px;
    text-shadow: -10px -5px 0 rgba(255, 255, 255, 0.1);
  }

  .hide-on-responsive {
    display: none;
  }

  .custom-row {
    padding-block: 0.5em;
  }

  .main-container-new .content p {
    font-family: "Poppins";
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0em;
    text-align: center;
    color: rgba(255, 255, 255, 1);
    margin: 10px 0px 30px 0px;
    width: 100%;
    margin-inline: auto;
  }

  .main-container-new .content {
    padding: 20px;
  }

  .invester-new {
    margin-top: 70px;
  }

  .sec-two .two {
    width: 90%;
  }

  .sec-two .text-start {
    width: 100%;
    margin-inline: auto;
    font-weight: 700;
    line-height: 36px;
    font-size: 40px;
    margin-bottom: 20px !important;
  }

  .sec-two .normal-p {
    width: 100%;
  }

  .sec-three {
    padding: 40px 10px;
  }

  .sec-three h2 {
    font-size: 36px;
    font-weight: 700;
    line-height: 42px;
    text-align: center;
    width: 100%;
  }

  .sec-three p {
    width: 100%;
    text-align: center;
  }

  .sec-three .button {
    text-align: center;
    margin-bottom: 40px;
  }

  .sec-three .video {
    text-align: center;
  }

  .sec-three .background {
    width: 100%;
  }

  .sec-three .video video {
    width: 90%;
  }

  .sec-three .background img {
    width: 60px;
    height: 60px;
  }

  .sec-four {
    padding-bottom: 40px;
    padding-top: 40px;
  }

  .sec-four h2 {
    width: 100%;
    font-size: 36px;
    line-height: 42px;
  }

  .join-banner p {
    font-size: 11px;
  }

  .sec-four .sec10-container {
    margin-bottom: 15px;
  }

  .sec-five {
    padding: 0px 10px 40px 10px;
  }

  .sec-five .layout-text-profit {
    align-items: center;
    margin-bottom: 40px;
  }

  .sec-five .layout-text-profit h3 {
    width: 100%;
    text-align: center;
  }

  .sec-six {
    flex-direction: column;
  }

  .sec-six .left .new-para {
    padding-inline: 10px;
  }

  .sec-six .left img {
    height: 65vh;
    width: 100%;
  }

  .sec-six .right {
    padding: 20px;
  }

  .sec-six h3 {
    width: 100%;
    text-align: center;
  }

  .sec-six p {
    width: 100%;
    text-align: center;
  }

  .sec-six .button {
    text-align: center;
    width: 100%;
  }

  .sec-seven {
    padding: 40px 10px;
  }

  .sec-seven .title {
    width: 100%;
    text-align: center;
    font-size: 36px;
    line-height: 42px;
  }

  .sec-seven .desc {
    width: 100%;
    text-align: center;
  }

  .sec-eight .sec-eight-wrap .inner {
    flex-direction: column;
  }

  .sec-eight .sec-eight-wrap .inner .left {
    width: 100%;
  }

  .sec-eight .sec-eight-wrap .inner .right {
    width: 100%;
  }

  .sec-eight .right .p-c-wrapper {
    flex-direction: column;
  }

  .sec-eight .right {
    padding: 10px;
  }

  .sec-eight .sec10-container .sec10-list .sec10-title h3 {
    color: #bababa;
    font-family: "Poppins";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin: 0;
  }

  .sec-nine {
    padding-top: 30px;
    overflow: hidden;
  }

  .sec-nine .desc {
    width: 100%;
    text-align: center;
  }

  .sec-nine .investor-card {
    display: flex;
    padding: 0px;
    flex-direction: column;
  }

  .sec-nine .investor-card-body .bt1 {
    margin-bottom: 0px;
    width: 30px;
  }

  .sec-nine .investor-card-body .bt2 {
    margin-top: 0px;
    width: 30px;
  }

  .sec-nine .investor-card-body {
    padding: 10px;
  }

  .sec-ten {
    padding-top: 0px;
    padding-inline: 0px;
    overflow: hidden;
  }

  .sec-nine .investor-card .investor-card-img {
    width: 200px;
    height: 200px;
  }

  .sec-nine .investor-card .investor-card-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .sec-nine .slick-prev {
    width: 50px;
  }

  .sec-nine .slick-next {
    width: 50px;
  }

  .sec-eleven {
    padding-top: 10px;
    padding-bottom: 40px;
  }

  .sec-eleven form {
    padding: 25px 15px;
  }

  .sec-eleven form .type .left p {
    font-size: 10px;
  }

  .sec-eleven form .type .right p {
    font-size: 10px;
  }

  .sec-seven .card-wrap {
    background: #fff;
    height: 100%;
    padding: 15px 0px;
    position: relative;
  }

  .open-header {
    /* padding-right: 1em; */
    padding-top: 1rem !important;
  }

  .sec-eight .sec-eight-wrap .inner .left .parent .parent-p {
    padding: 10px 0px 10px 30px;
  }

  .sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu li {
    padding-left: 50px;
  }

  .sec-eight .sec-eight-wrap .inner .left {
    background: #232323;
    padding-bottom: 10px;
  }

  .sec-eleven form .row:nth-child(3) h3 {
    margin-top: 20px;
  }
}

@media (max-width: 1020px) {
  .notification-card {
    top: 60px;
    right: 33px;
    left: auto;
  }

  .not-top-icon {
    right: 55px;
  }

  /* .not-top-main-icon {
    right: 108px;
  } */
}

@media (max-width: 500px) {
  /* .not-top-main-icon {
    right: 82px;
  } */
  .notification-card-main {
    right: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,iCAAiC;IACjC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;;EAEA,uDAAuD;EACvD;IACE,+BAA+B;IAC/B,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,2BAA2B;IAC3B,iCAAiC;IACjC,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,iBAAiB;IACjB,0BAA0B;EAC5B;EACA;IACE,WAAW;IACX,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;EACA;IACE,mCAAmC;IACnC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;EACpB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,SAAS;EACX;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;;OAEK;EACL;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;AACF;AACA;EACE;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,QAAQ;EACR;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;;GAGG;;AAEH;EACE,QAAQ;EACR;IACE,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;;;GAGG;;AAEH;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,kBAAkB;EACpB;AACF;;AAEA;;;GAGG;;AAEH;EACE,QAAQ;AACV;;AAEA;;;GAGG;;AAEH;EACE,QAAQ;AACV;;AAEA;;;GAGG;;AAEH,YAAY;AACZ;EACE;IACE,aAAa;EACf;;EAEA;EACA;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,8BAA8B;EAChC;;EAEA;;;;;IAKE,6BAA6B;EAC/B;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAqIE,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;IAClB,QAAQ;EACV;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAiKE,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,2CAA2C;IAC3C,2BAA2B;EAC7B;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;;;;;;IAWE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;EACA;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,YAAY;EACZ;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,8BAA8B;IAC9B,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA,gBAAgB;;EAEhB;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;KACG;EACH;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,YAAY;AACZ;EACE;;;;;;;;;;;IAWE,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,QAAQ;EACR;IACE,uBAAuB;IACvB,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;KAGG;AACL;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;KAGG;AACL;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;KAEG;;EAEH;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,aAAa;EACf;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qCAAqC;EACvC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;KAEG;;EAEH;IACE,qCAAqC;EACvC;EACA;IACE,kCAAkC;EACpC;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAU;IACV,+CAA+C;EACjD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,aAAa;EACf;;EAEA;IACE,eAAe;IACf,kDAAkD;EACpD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;;KAEG;AACL;;AAEA;EACE;;KAEG;EACH;IACE,WAAW;EACb;AACF","sourcesContent":["/* \n  ##Device = Desktops\n  ##Screen = 1281px to higher resolution desktops\n*/\n@media (max-width: 991px) {\n  .not-top-icon {\n    top: 23px;\n  }\n\n  .bg-video {\n    display: none;\n  }\n  .home-sec-testimonial .home-slider-next {\n    display: none;\n  }\n  .home-sec-testimonial .home-slider-prev {\n    display: none;\n  }\n  .mobile-nav {\n    display: block;\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background: #000;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 9999;\n    transform: translateX(100%);\n    transition: transform 0.5s linear;\n    padding: 20px;\n  }\n\n  .mobile-nav .one {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .mobile-nav .two {\n    margin-top: 36px;\n    height: calc(100vh - 93.64px);\n    display: flex;\n    justify-content: center;\n    align-items: start;\n  }\n\n  .mobile-nav .one .one-right svg {\n    font-size: 30px;\n    color: #fff;\n    cursor: pointer;\n  }\n\n  .mobile-nav .two ul li {\n    text-align: center;\n    font-size: 20px;\n    color: #f6f6f6;\n    font-weight: 500;\n    margin-bottom: 0px;\n    margin-top: 20px;\n  }\n\n  .simple-btn.login {\n    display: none;\n  }\n\n  header .header-wrap .left {\n    width: 100%;\n  }\n\n  header .header-wrap {\n    padding-inline: 20px;\n  }\n\n  .hamburger-mobile {\n    display: block;\n  }\n\n  .hamburger-mobile ul {\n    margin: 0;\n    padding: 0;\n  }\n\n  .hamburger-mobile ul li svg {\n    font-size: 28px;\n    color: #e11f1c;\n  }\n\n  header .header-wrap .center {\n    display: none;\n  }\n\n  .language-btn {\n    display: none;\n  }\n\n  .lp-btn {\n    /* display: none !important; */\n  }\n  .lp-btnn {\n    display: none !important;\n  }\n\n  /* For logout button responsive on tablet and mobiles */\n  .profile-card .admin-profile-logout {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n  }\n\n  .lp-news-btn {\n    display: none;\n  }\n\n  .join-banner-news {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .join-banner-news {\n    padding: 5px;\n  }\n  .join-banner-news img {\n    width: 200px;\n    object-fit: contain;\n  }\n  .mobile-nav {\n    display: block;\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background: #3e3e3e;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 9999;\n    transform: translateX(100%);\n    transition: transform 0.5s linear;\n    padding: 30px;\n  }\n  .data-0twelve {\n    display: block;\n  }\n  .home-sec-testimonial {\n    padding-inline: 12px;\n    overflow-x: hidden;\n  }\n  .home-sec-testimonial {\n    padding: 60px 0px;\n  }\n  .home-sec-testimonial .slick-prev {\n    left: -45px;\n  }\n  .home-sec-testimonial .slick-next {\n    right: -45px;\n  }\n  .storeSection .InvestCardCon {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .storeSectionDetail .top {\n    flex-direction: column;\n    align-items: start;\n    padding-inline: 10px;\n  }\n  .storeSectionDetail .bottom .container {\n    flex-direction: column-reverse;\n    align-items: start;\n    margin: 0;\n    width: 100%;\n    max-width: none;\n    margin-bottom: 30px;\n  }\n  .storeSectionDetail .bottom .container .right {\n    width: 100%;\n  }\n  .storeSectionDetail .top-heading {\n    margin-top: 40px;\n  }\n  .storeSectionDetail .top .left {\n    width: 100%;\n    padding-right: 50px;\n  }\n  .storeSectionDetail .top .right {\n    width: 100%;\n    padding-right: 50px;\n  }\n}\n\n@media (max-width: 768px) {\n  .offer-modal-sec .offer-modal-img img {\n    width: 134px;\n  }\n\n  .offer-modal-img .text p {\n    font-size: 9px;\n    width: 95px;\n    line-height: 15px;\n  }\n  .offer-modal-img .text p span {\n    font-size: 10px !important;\n  }\n  .storeSectionDetail .swiper-slide .type-img {\n    height: 250px;\n  }\n  .storeSectionDetail .swiper-slide .wrap-video .background img:nth-child(1) {\n    height: 250px;\n  }\n  .storeSectionDetail .bottom .container .left h1 {\n    font-size: 40px;\n    line-height: 40px;\n  }\n  .storeSectionDetail .top-heading p {\n    text-align: start;\n  }\n  .storeSectionDetail .top .right {\n    padding-right: 0;\n  }\n  .storeSection .InvestCardCon .InvestCard .top {\n    height: auto;\n  }\n  .css-2u6ojp-MuiContainer-root {\n    padding: 0px 12px;\n  }\n  .storeSection .content .heading {\n    font-size: 60px;\n    line-height: 68px;\n  }\n  .storeSection .content .sub-heading {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .storeSection .InvestCardCon {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  .storeSection .search-con {\n    flex-direction: column;\n  }\n  .storeSection .search-con .left {\n    border: none;\n    padding-inline: 6px;\n  }\n  .storeSection .search-con .left input {\n    /* padding: 8px 40px; */\n    line-height: 20px;\n    padding-inline-start: 40px;\n  }\n  .storeSection .search-con .left .wrap .search-icon {\n    width: 30px;\n    left: 20px;\n  }\n  .storeSection .InvestCardCon .InvestCard .bottom {\n    padding: 16px;\n  }\n  .storeSection .search-con .right {\n    width: 100%;\n    padding-inline: 6px;\n  }\n  .storeSection .search-con .right .store-select-wrapper {\n    width: 100% !important;\n  }\n  .storeSectionDetail .top-heading h1 {\n    font-size: 50px;\n    line-height: 52px;\n  }\n  .storeSectionDetail .bottom .main-heading {\n    margin-bottom: 50px;\n  }\n  .home-sec-1 .home-sec-1-left h1 span {\n    color: #fff;\n  }\n  .home-sec-1 {\n    margin-top: 0px !important;\n  }\n\n  header .header-wrap {\n    padding-inline: 20px;\n  }\n\n  .sec-four .sec10-container .sec10-list .sec10-title {\n    gap: 20px;\n  }\n  .home-sec-three p {\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .checkout-field-referral-box {\n    justify-content: center !important;\n  }\n  .home-sec-testimonial {\n    padding: 40px 0px;\n  }\n  .card-1,\n  .card-2 {\n    width: 380px;\n    height: 480px;\n  }\n\n  .signature-sec {\n    margin-top: 20px;\n    padding: 0px;\n  }\n\n  .signature-sec .top .top-1 {\n    flex-direction: row !important;\n  }\n\n  .top .top-2 #convas {\n    width: 95%;\n  }\n  .css-2u6ojp-MuiContainer-root {\n    width: calc(100% - 78px) !important;\n    padding: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .css-vj1n65-MuiGrid-root{\n    width: 100%;\n  }\n  .MuiGrid-root.MuiGrid-container.css-11lq3yg-MuiGrid-root{\n    flex-wrap: nowrap !important;\n  }\n  .container-withdrawl {\n    flex-direction: column;\n    align-items: center;\n    flex-direction: column-reverse;\n    /* margin: 20px; */\n  }\n  .mainContainerComp .form-control{\n    padding-inline-start: 12px;\n  }\n  .mainContainerComp .form-select{\n    padding-inline-start: 12px;\n  }\n  .css-1jt94r9-MuiGrid-root{\n    width: 100% !important;\n  }\n\n  .balance-withdrawl {\n    font-size: 20px !important;\n  }\n\n  .doc-with-title .doc-title {\n    font-family: \"Bebas Neue\";\n    font-size: 35px;\n    font-weight: 700;\n    line-height: 35px;\n    letter-spacing: 0em;\n    text-align: left;\n  }\n\n  .doc-with-title {\n    padding-left: 0px;\n  }\n  .css-2u6ojp-MuiContainer-root {\n    width: 100%;\n  }\n\n  .other-details {\n    display: flex;\n    padding-left: 0px;\n    flex-direction: column;\n  }\n\n  .other-details h4 {\n    margin-top: 10px;\n    font-size: 22px;\n    font-weight: 600;\n    line-height: 26px;\n  }\n\n  .other-details p {\n    font-family: \"Raleway\";\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    letter-spacing: 0em;\n    text-align: left;\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .doc-card {\n    margin: 20px 0px;\n    height: 350px;\n  }\n\n  .home-sec-ten {\n    padding: 40px 0;\n  }\n  .dashboard-box {\n    flex-direction: column;\n    height: auto;\n    gap: 20px;\n  }\n  .dashboard-box h3 {\n    text-align: center;\n  }\n  .dashboard-box h4 {\n    text-align: center;\n  }\n  .dashboard-box h6 {\n    text-align: center;\n  }\n}\n\n@media (max-width: 500px) {\n  .dashboard-box img {\n    margin-bottom: 10px;\n  }\n  .css-1p16mnu {\n    padding-top: 39px;\n  }\n  .storeSectionDetail .top-heading h1 {\n    font-size: 30px;\n    line-height: 38px;\n  }\n  .storeSectionDetail .bottom .main-heading {\n    font-size: 40px;\n    line-height: 48px;\n  }\n  .storeSectionDetail .bottom {\n    margin-bottom: 40px;\n  }\n  .storeSectionDetail .bottom .container .left h1 {\n    font-size: 40px;\n    line-height: 40px;\n  }\n}\n@media (max-width: 420px) {\n  /* .modal-dialog-centered{\n    margin-top: 20px !important;\n    } */\n  .css-hyum1k-MuiToolbar-root {\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n    gap: 15px;\n  }\n  .simple-square-btn {\n    /* padding: 5px 8px; */\n  }\n}\n@media (max-width: 400px) {\n  .storeSection .InvestCardCon .InvestCard .bottom .box1 {\n    flex-direction: column;\n    align-items: start;\n  }\n  .storeSection .InvestCardCon .InvestCard .bottom .box2 {\n    flex-direction: column;\n    align-items: start;\n  }\n}\n\n@media (min-width: 320px) and (max-width: 500px) {\n  .card-1,\n  .card-2 {\n    width: 350px;\n    height: 480px;\n  }\n\n  .layout_currency-text {\n    font-size: 15px;\n  }\n\n  .primary-btn-profit {\n    font-size: 17px !important;\n    padding: 10px 13px;\n    border-radius: 10px;\n  }\n  .css-tzsjye {\n    margin-top: 30px !important;\n    width: 100% !important;\n  }\n  .css-i6s8oy {\n    display: block !important;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .sec-five .layout-text-profit {\n    align-items: center;\n  }\n\n  .card-1,\n  .card-2 {\n    width: 360px;\n    height: 500px;\n  }\n\n  .layout_currency-text {\n    font-size: 15px;\n  }\n\n  .primary-btn-profit {\n    font-size: 17px;\n  }\n}\n\n@media (max-width: 320px) {\n  .card-1,\n  .card-2 {\n    width: 300px;\n    height: 500px;\n  }\n\n  .card-1 {\n    padding-top: 2rem;\n    padding-left: 0.4rem;\n  }\n\n  .layout_currency-text {\n    font-size: 12px;\n    padding: 12px;\n  }\n\n  .primary-btn-profit {\n    font-size: 13px !important;\n    padding: 10px 13px;\n    border-radius: 10px;\n  }\n}\n\n@media (min-width: 1020px) {\n  /* CSS */\n  .header-button {\n    display: none;\n  }\n\n  .not-button {\n    display: none;\n  }\n\n  .mobile-header {\n    display: none;\n  }\n}\n\n/* \n    ##Device = Laptops, Desktops\n    ##Screen = B/w 1025px to 1280px\n  */\n\n@media (min-width: 1024px) and (max-width: 1280px) {\n  /* CSS */\n  .header-body li a {\n    padding: 0 0.7rem !important;\n    font-size: 10px !important;\n  }\n\n  .custom-header .btn {\n    font-size: 12px !important;\n  }\n\n  .custom-card {\n    width: 260px;\n  }\n\n  .banner-text {\n    font-size: 70px;\n  }\n\n  .team-img-1 {\n    width: 100%;\n  }\n\n  .team-img-2 {\n    height: 100%;\n  }\n\n  .invest-second .invest-search-input input {\n    width: 460px;\n  }\n\n  .investment-section h2 {\n    font-size: 60px;\n  }\n\n  .section2 .img img {\n    width: 65%;\n  }\n}\n\n/* \n    ##Device = Tablets, Ipads (portrait)\n    ##Screen = B/w 768px to 1024px\n  */\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .custom-card {\n    width: 100%;\n  }\n\n  .custom-card-two {\n    width: 100%;\n  }\n\n  .main-header\n    .language-btn:not(.mobile-header .language-btn)\n    .pitch-card-wrapper {\n    margin-top: 4.8rem;\n  }\n}\n\n/* \n    ##Device = Tablets, Ipads (landscape)\n    ##Screen = B/w 768px to 1024px\n  */\n\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n  /* CSS */\n}\n\n/* \n    ##Device = Low Resolution Tablets, Mobiles (Landscape)\n    ##Screen = B/w 481px to 767px\n  */\n\n@media (min-width: 481px) and (max-width: 768px) {\n  /* CSS */\n}\n\n/* \n    ##Device = Most of the Smartphones Mobiles (Portrait)\n    ##Screen = B/w 320px to 479px\n  */\n\n/* Tablets */\n@media (max-width: 991px) {\n  .home-sec-twelve .data {\n    display: none;\n  }\n\n  .data-0twelve {\n  }\n\n  .data-0twelve h1 {\n    font-size: 35px;\n    font-weight: 800;\n    line-height: 45.57px;\n    text-align: center;\n    color: #252525;\n    margin-bottom: 12px;\n    margin-top: 30px;\n    margin-bottom: 20px;\n  }\n\n  .data-0twelve h1 span {\n    color: #e11f1c;\n  }\n\n  .data-0twelve .cardd {\n    padding: 20px;\n    border: 2px solid #252525;\n    border-radius: 12px;\n    margin-bottom: 20px;\n  }\n\n  .data-0twelve .cardd h1 {\n    font-size: 35px;\n    font-weight: 800;\n    line-height: 45.57px;\n    text-align: center;\n    color: #e11f1c;\n    margin-bottom: 12px;\n  }\n  .data-0twelve .cardd h3 {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 25.6px;\n    text-align: center;\n    color: #252525;\n    margin-bottom: 10px;\n  }\n\n  .data-0twelve .cardd p {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 25.6px;\n    text-align: center;\n    color: #252525;\n  }\n\n  .home-sec-twelve {\n    height: auto;\n  }\n\n  .data-0twelve .button {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n  }\n  .data-0twelve .button button {\n    border-radius: 5px;\n    padding: 15px 25px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    color: #fff;\n    background-color: #252525;\n    border: none;\n  }\n\n  .home-sec-twelve {\n    margin: 0;\n  }\n\n  .home-sec-twelve .bg-video,\n  .home-sec-twelve .content,\n  .home-sec-twelve .content-card {\n    position: static;\n  }\n\n  .sec-four h2 {\n    width: 100%;\n  }\n\n  .home-sec-seven h3 {\n    width: 100%;\n  }\n\n  .home-sec-six .home-sec-six-right img {\n    margin-top: 30px;\n  }\n\n  header {\n    background-color: #fff;\n  }\n\n  .home-sec-five .left .home-sec-five-left-two,\n  .home-sec-five .left .home-sec-five-left-three {\n    margin-right: 0px;\n    margin-left: 0px;\n  }\n\n  .home-sec-five .home-sec-five-center img {\n    width: 100%;\n    margin: 30px 0px;\n  }\n\n  .home-sec-five .right .home-sec-five-right-two,\n  .home-sec-five .right .home-sec-five-right-three {\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n\n  .home-sec-five h3 {\n    font-size: 35px;\n    font-weight: 800;\n    line-height: 45.57px;\n    text-align: center;\n    color: #252525;\n    margin-bottom: 20px;\n    width: 100%;\n    margin-inline: auto;\n  }\n\n  .home-sec-1 {\n    padding: 130px 0px;\n    background-position: right;\n    margin-top: 200px;\n  }\n  .close-icon-sec7 {\n    position: absolute;\n    top: -10px;\n    right: 44px;\n  }\n\n  .home-sec-1 .home-sec-1-left h1 {\n    font-size: 42px;\n    font-weight: 400;\n    line-height: 52.63px;\n    text-align: left;\n    margin-bottom: 20px !important;\n  }\n\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(2) {\n    background-color: transparent;\n  }\n\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(1)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(3)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(4)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(6)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(7)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(9)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(10)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(12)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(13)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(15)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(16)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(18)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(19)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(21)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(22)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(24)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(25)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(27)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(28)\n    div\n    .person-item-wrapper {\n    background: #fff;\n    border: 2px solid #fff;\n    border-radius: 16px;\n    padding: 23px;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    margin: 10px;\n    position: relative;\n    top: 0px;\n  }\n\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(2)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(5)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(8)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(11)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(14)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(17)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(20)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(23)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(26)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(29)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(32)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(35)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(38)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(41)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(44)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(47)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(50)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(53)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(56)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(59)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(62)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(65)\n    div\n    .person-item-wrapper,\n  .home-sec-two\n    .slick-slider\n    .slick-list\n    .slick-track\n    .slick-slide:nth-child(68)\n    div\n    .person-item-wrapper {\n    background: #252525;\n    border: 2px solid #fff;\n    border-radius: 16px;\n    padding: 23px;\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n    margin: 10px 10px 10px 10px;\n  }\n\n  .home-sec-two {\n    padding-inline: 139px;\n    margin-top: -110px;\n  }\n\n  .home-sec-1 .home-sec-1-left .button button:nth-child(2) {\n    padding: 15px 25px;\n    color: #252525;\n    background-color: #fff;\n    border-radius: 5px;\n    border: 1px solid #fff;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 20.83px;\n    text-align: left;\n  }\n\n  .home-sec-1 .home-sec-1-left p {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 25.6px;\n    text-align: left;\n    /* color: #252525; */\n    margin-bottom: 25px !important;\n  }\n\n  .home-sec-three .home-sec-three-left img {\n    margin-bottom: 30px;\n  }\n\n  .home-sec-four .home-sec-four-right img {\n    margin-top: 30px;\n  }\n\n  .home-sec-twelve,\n  .home-sec-eleven,\n  .home-sec-ten,\n  .home-sec-eight,\n  .home-sec-seven,\n  .home-sec-six,\n  .home-sec-five,\n  .home-sec-four,\n  .home-sec-three,\n  .home-sec-two,\n  .home-sec-one {\n    padding: 60px 0px;\n  }\n\n  .home-sec-eleven .right {\n    margin-top: 30px;\n  }\n\n  .mobile-nav .two ul {\n    margin: 0;\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .mobile-nav .two ul {\n  }\n\n  .language-btnn {\n    margin-top: 30px;\n    margin-inline: 0px;\n  }\n\n  /* header  */\n  .line-red {\n    display: none;\n  }\n\n  .hide-on-responsive {\n    display: none;\n  }\n\n  .padding-from-left-for-chart_1 {\n    padding-left: 7%;\n  }\n\n  .padding-from-left-for-chart {\n    padding-left: 5%;\n  }\n\n  .header-main {\n    position: fixed;\n    top: 0;\n    right: 0;\n    background: var(--white);\n    height: 100%;\n    z-index: 1;\n    overflow: auto;\n  }\n\n  .header-hide {\n    width: 0px;\n    transition: all 0.4s ease-in-out;\n  }\n\n  .mobile-hide {\n    display: none !important;\n  }\n\n  .mobile-show {\n    display: block !important;\n  }\n\n  .header-show {\n    width: 300px;\n    transition: all 0.4s ease-in-out;\n  }\n\n  .header-main .header-body {\n    flex-direction: column;\n    align-items: flex-start !important;\n  }\n\n  .header-body li {\n    padding: 0 0.5rem;\n  }\n\n  .mobile-header-top {\n    display: flex !important;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 0;\n    margin: 0 1rem;\n    margin-bottom: 1rem !important;\n    border-bottom: 1px solid;\n    border-color: var(--primary);\n  }\n\n  .mobile-header-top img {\n    width: 100px;\n  }\n\n  .mobile-header-top .cross-icon {\n    color: black;\n  }\n\n  .header-bottom {\n    display: block !important;\n    padding: 1rem 1.5rem;\n  }\n\n  /* header end  */\n\n  .team-img-1 {\n    height: 100%;\n    width: 100%;\n  }\n\n  .team-img-2 {\n    height: 100%;\n  }\n\n  .card-lg {\n    width: 100% !important;\n    padding: 0 0.9rem;\n  }\n\n  /* .custom-card-two {\n  } */\n  .banner-text {\n    font-size: 50px;\n  }\n\n  .common-heading {\n    margin-bottom: 30px;\n  }\n\n  .invest-second .invest-search-input input {\n    width: 450px;\n  }\n\n  .investment-section h2 {\n    font-size: 40px;\n  }\n\n  .investment-section h4 {\n    font-size: 18px;\n  }\n\n  .col-without-padding {\n    display: flex;\n  }\n\n  .col-without-padding .about-card-order-1 {\n    order: 1;\n  }\n\n  .col-without-padding .about-card-order-2 {\n    order: 2;\n  }\n\n  .col-without-padding .about-card-order-3 {\n    order: 3;\n  }\n\n  .col-without-padding .about-card-order-3 img {\n    width: 100%;\n  }\n\n  .col-without-padding .about-card-order-4 {\n    order: 4;\n  }\n\n  .items img {\n    width: 200px;\n  }\n\n  .items .title-section {\n    justify-content: space-between;\n  }\n\n  .chevron-icon {\n    display: inline-flex !important;\n  }\n\n  #investment-simulation .image img {\n    width: 50%;\n  }\n\n  .investment-second h2 {\n    font-size: 40px;\n  }\n\n  #investment-simulation .bg-image .content h3 {\n    margin: 0px;\n    font-size: 18px;\n  }\n\n  .section2 .img img {\n    width: 50%;\n  }\n\n  #section-bg-atteched .background-text .common-heading {\n    font-size: 26px;\n  }\n}\n\n@media (min-width: 991px) {\n  .sidebar {\n    position: relative !important;\n  }\n\n  .sidebar.open {\n    width: 300px !important;\n  }\n\n  .dashboard-section-main {\n    margin-left: 0px !important;\n  }\n}\n\n/* Tablets */\n@media (max-width: 767px) {\n  .home-sec-twelve,\n  .home-sec-eleven,\n  .home-sec-ten,\n  .home-sec-eight,\n  .home-sec-seven,\n  .home-sec-six,\n  .home-sec-five,\n  .home-sec-four,\n  .home-sec-three,\n  .home-sec-two,\n  .home-sec-one {\n    padding: 30px 0px;\n  }\n\n  .sec-five .card-11,\n  .sec-five .card-22 {\n    padding: 30px;\n  }\n\n  .home-sec-seven .video {\n    position: relative;\n    height: 299px;\n  }\n\n  .home-sec-seven .video .right-img,\n  .home-sec-seven .video .left-img {\n    display: none;\n  }\n\n  .home-sec-seven .video .background {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n  }\n\n  .items .title-section {\n    justify-content: space-between;\n  }\n\n  .items .title-section h3 {\n    margin: 0;\n    font-size: 18px;\n  }\n\n  .items p {\n    font-size: 16px;\n    margin-top: 1rem;\n  }\n\n  .items img {\n    width: 150px;\n  }\n\n  .invest-second .invest-search-input input {\n    width: 95%;\n  }\n\n  .investment-second {\n    margin-top: 50px;\n    text-align: center;\n  }\n\n  .investment-second h3 {\n    font-size: 24px;\n  }\n\n  .investment-second h2 {\n    font-size: 35px;\n  }\n\n  .invest-second img {\n    width: 70%;\n  }\n\n  .investment-second p {\n    font-size: 16px;\n  }\n\n  .join-section .custom-input {\n    width: 375px !important;\n  }\n\n  .blog-body h3 {\n    font-size: 22px;\n  }\n\n  .target-img img {\n    margin: auto;\n  }\n\n  .section-title {\n    font-size: 25px;\n  }\n\n  .main-container-new .content h1 {\n    font-family: \"Poppins\";\n    font-size: 36px;\n    font-weight: 700;\n    line-height: 48px;\n    letter-spacing: 0em;\n    text-align: center;\n    color: rgba(255, 255, 255, 1);\n    width: 100%;\n    margin-inline: auto;\n    padding-top: 60px;\n  }\n}\n\n/* Extra Small Devices, Phones */\n@media (max-width: 480px) {\n  .contact-image {\n    width: 100%;\n  }\n\n  .checkout-terms {\n    font-size: 1rem;\n    font-weight: 400;\n  }\n\n  .section2 .img img {\n    width: 100%;\n  }\n\n  #investment-simulation .bg-image .content h3 {\n    margin: 0px;\n    font-size: 12px;\n  }\n\n  #section-bg-atteched .background-text .common-heading {\n    font-size: 20px;\n  }\n\n  .items .title-section .first {\n    width: 75%;\n  }\n\n  .banner-text {\n    font-size: 22px;\n  }\n\n  .home-banner {\n    font-size: 35px;\n  }\n\n  .banner-inner {\n    height: 500px;\n  }\n\n  .logo-section img {\n    width: 60% !important;\n  }\n\n  .section-title {\n    font-size: 14px !important;\n  }\n}\n\n@media (min-width: 320px) and (max-width: 480px) {\n  /* CSS */\n  .join-section .custom-input {\n    width: 200px !important;\n    margin-right: 1.5rem !important;\n  }\n}\n\n@media (max-width: 425px) {\n  .main-search {\n    display: flex !important;\n    flex-wrap: wrap;\n  }\n\n  .main-search .invest-search-input {\n    order: 1;\n    flex-basis: 100%;\n    margin-bottom: 25px;\n  }\n\n  .main-search .invest-drop-down {\n    order: 2;\n    flex-basis: 47%;\n  }\n\n  .main-search .search-btn {\n    order: 3;\n    flex-basis: 47%;\n  }\n\n  .main-search .css-pe0pe4-MuiFormControl-root {\n    width: 100%;\n  }\n\n  .main-search .search-btn .btn {\n    width: 100% !important;\n  }\n\n  .custom-card img {\n    width: 95%;\n  }\n\n  .custom-card .tag {\n    top: -35px;\n    right: 0px;\n  }\n}\n\n@media screen and (max-width: 1049px) {\n  .section-title {\n    font-size: 35px;\n  }\n\n  .bg-video-landing {\n    width: auto;\n  }\n\n  .main-container {\n    padding-top: 3rem;\n  }\n\n  .grid-section2 .large-p,\n  .accordion-button {\n    font-size: 20px;\n  }\n\n  .normal-p,\n  .accordion-body {\n    font-size: 16px !important;\n  }\n}\n\n@media screen and (min-width: 768px) {\n  /* .header-button,\n  .mobile-header {\n    display: none !important;\n  } */\n}\n\n@media screen and (max-width: 1020px) {\n  .main-header .button-group {\n    display: none;\n  }\n\n  /* .header-button,\n  .mobile-header {\n    display: none !important;\n  } */\n}\n\n@media screen and (max-width: 768px) {\n  .sec-two .text-start p {\n    font-size: 20px;\n    line-height: 32px;\n  }\n\n  .normal-p,\n  .normal-p * {\n    font-size: 16px;\n  }\n\n  .mobile-col-reverse {\n    flex-direction: column-reverse;\n  }\n\n  .main-header .language-btn:not(.mobile-header .language-btn) {\n    display: none;\n  }\n\n  .rounded-input-group {\n    width: 100%;\n  }\n\n  .mobile-header .language-btn {\n    display: flex;\n    justify-content: center;\n    margin: 0;\n  }\n\n  .main-header-link,\n  .main-header .lp-btn:not(.mobile-header .lp-btn) {\n    display: none;\n  }\n\n  .col-mobile-reverse {\n    flex-direction: column-reverse;\n  }\n\n  .main-section .row p {\n    padding: 0 !important;\n  }\n\n  .main-logo {\n    width: 50px;\n    height: auto;\n  }\n\n  /* a.main-header-link {\n    display: none;\n  } */\n\n  .header-line {\n    height: 24px;\n  }\n\n  .main-header button {\n    font-size: 0.9rem;\n  }\n\n  .main-header-link {\n    font-size: 0.9rem;\n  }\n\n  .main-section {\n    /* padding-bottom: 3em; */\n  }\n\n  .main-section-text {\n    padding-right: 0;\n  }\n\n  .custom-section.get-started-section {\n    padding: 3rem 0;\n  }\n\n  .get-started-body {\n    width: 100%;\n  }\n\n  .stat-box {\n    padding: 0.7em;\n  }\n\n  .stat-number {\n    font-size: 2.5vw;\n  }\n\n  .stat-icon {\n    width: 30px;\n  }\n\n  .stat-label {\n    font-size: 2.5vw;\n  }\n\n  .section-title {\n    font-size: 25px;\n    margin-bottom: 1em;\n  }\n\n  .accordion-section {\n    padding-bottom: 0;\n  }\n\n  .normal-p,\n  .accordion-body {\n    font-size: 14px !important;\n  }\n\n  .sidebar:not(.open) {\n    width: 60px !important;\n    left: 0px !important;\n  }\n\n  .dashboard-section-main {\n    margin-left: 60px !important;\n  }\n\n  .main-section {\n    /* margin-left: 60px !important; */\n  }\n\n  .sidebar .logo-details #btn {\n    right: 0 !important;\n  }\n\n  .main-section .row {\n    justify-content: center;\n  }\n\n  .open-sidebar .button-group {\n    transform: translateX(180px);\n  }\n\n  .sidebar.open {\n    /* padding-left: 2em; */\n  }\n\n  footer .footer-social .common-heading {\n    margin-bottom: 5px;\n  }\n\n  .lp-shop-crop {\n    width: 100%;\n    transform: none;\n  }\n\n  .landing-page .main-section-text {\n    justify-content: flex-end !important;\n  }\n\n  .main-section-text p {\n    padding: 0 1rem;\n  }\n\n  .main-section-text p:first-child {\n    padding-bottom: 0.7em;\n  }\n\n  .pure-section-text {\n    width: 100%;\n    text-align: justify;\n    text-align-last: center;\n  }\n\n  .custom-section.pure-section {\n    padding: 4rem 2rem;\n  }\n  .custom-box {\n    padding: 16px;\n    margin: 4px;\n  }\n  .card-bg-img {\n    display: none;\n  }\n  .custom-header .logo-section {\n    padding-inline-start: 10px;\n  }\n  .header-body {\n    gap: 8px !important;\n  }\n  .wallet-cardd {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .mainContainerComp {\n    padding: 16px !important;\n  }\n  .userContainer {\n    padding: 16px  !important;\n  }\n  .mainContainerComp .send-notification-btn{\n    min-width: 0px;\n  }\n}\n\n@media (max-width: 500px) {\n  /* .dashboard-logo {\n    display: none;\n  } */\n\n  .wallet-cardd {\n    grid-template-columns: repeat(1, 1fr);\n  }\n  .dashboard-section-main {\n    /* padding-left: 1em !important; */\n  }\n  .dashboard-box h4 {\n    text-align: center;\n  }\n\n  .dashboard-section-main .MuiContainer-root {\n    padding-left: 0;\n    padding-right: 4px;\n  }\n\n  .stat-box {\n    padding: 0.5em;\n  }\n\n  .stat-number {\n    font-size: 3.5vw;\n  }\n\n  .stat-label {\n    font-size: 3vw !important;\n  }\n\n  .stat-box.order-1 {\n    transform: translateX(50%);\n  }\n\n  .stat-box.order-2 {\n    transform: translateX(50%);\n  }\n\n  .stat-box.order-5 {\n    transform: translateX(50%);\n  }\n\n  .custom-header {\n    padding: 1rem 0 !important;\n  }\n}\n\n@media (max-width: 768px) {\n  .Heading-row-t2 {\n    display: none;\n  }\n\n  .Table-of-content-inner {\n    flex: 100%;\n    /* Both tables take 100% width on mobile view */\n  }\n\n  .primary-tab {\n    font-size: 1rem;\n  }\n\n  .Content-main-heading-1 {\n    font-size: 45px;\n  }\n}\n\n@media (max-width: 767px) {\n  .New-login-form-Content {\n    flex: 100%;\n  }\n\n  .join-banner-news {\n    padding: 5px;\n  }\n\n  .New-login-form-form {\n    min-width: 300px;\n    margin: 20px auto !important;\n  }\n\n  .New-login-form-main {\n    height: auto;\n  }\n\n  .New-login-form-inside {\n    margin: 0 10px;\n  }\n\n  .Form-checkbox-holder,\n  .forget-password-btn {\n    font-size: 12px;\n  }\n\n  .Content-Main-Heading-container {\n    margin: 2% 5%;\n    height: 120px;\n  }\n\n  .Content-main-heading-1 {\n    font-size: 32px;\n    text-shadow: -10px -5px 0 rgba(255, 255, 255, 0.1);\n  }\n\n  .hide-on-responsive {\n    display: none;\n  }\n\n  .custom-row {\n    padding-block: 0.5em;\n  }\n\n  .main-container-new .content p {\n    font-family: \"Poppins\";\n    font-size: 24px;\n    font-weight: 500;\n    line-height: 32px;\n    letter-spacing: 0em;\n    text-align: center;\n    color: rgba(255, 255, 255, 1);\n    margin: 10px 0px 30px 0px;\n    width: 100%;\n    margin-inline: auto;\n  }\n\n  .main-container-new .content {\n    padding: 20px;\n  }\n\n  .invester-new {\n    margin-top: 70px;\n  }\n\n  .sec-two .two {\n    width: 90%;\n  }\n\n  .sec-two .text-start {\n    width: 100%;\n    margin-inline: auto;\n    font-weight: 700;\n    line-height: 36px;\n    font-size: 40px;\n    margin-bottom: 20px !important;\n  }\n\n  .sec-two .normal-p {\n    width: 100%;\n  }\n\n  .sec-three {\n    padding: 40px 10px;\n  }\n\n  .sec-three h2 {\n    font-size: 36px;\n    font-weight: 700;\n    line-height: 42px;\n    text-align: center;\n    width: 100%;\n  }\n\n  .sec-three p {\n    width: 100%;\n    text-align: center;\n  }\n\n  .sec-three .button {\n    text-align: center;\n    margin-bottom: 40px;\n  }\n\n  .sec-three .video {\n    text-align: center;\n  }\n\n  .sec-three .background {\n    width: 100%;\n  }\n\n  .sec-three .video video {\n    width: 90%;\n  }\n\n  .sec-three .background img {\n    width: 60px;\n    height: 60px;\n  }\n\n  .sec-four {\n    padding-bottom: 40px;\n    padding-top: 40px;\n  }\n\n  .sec-four h2 {\n    width: 100%;\n    font-size: 36px;\n    line-height: 42px;\n  }\n\n  .join-banner p {\n    font-size: 11px;\n  }\n\n  .sec-four .sec10-container {\n    margin-bottom: 15px;\n  }\n\n  .sec-five {\n    padding: 0px 10px 40px 10px;\n  }\n\n  .sec-five .layout-text-profit {\n    align-items: center;\n    margin-bottom: 40px;\n  }\n\n  .sec-five .layout-text-profit h3 {\n    width: 100%;\n    text-align: center;\n  }\n\n  .sec-six {\n    flex-direction: column;\n  }\n\n  .sec-six .left .new-para {\n    padding-inline: 10px;\n  }\n\n  .sec-six .left img {\n    height: 65vh;\n    width: 100%;\n  }\n\n  .sec-six .right {\n    padding: 20px;\n  }\n\n  .sec-six h3 {\n    width: 100%;\n    text-align: center;\n  }\n\n  .sec-six p {\n    width: 100%;\n    text-align: center;\n  }\n\n  .sec-six .button {\n    text-align: center;\n    width: 100%;\n  }\n\n  .sec-seven {\n    padding: 40px 10px;\n  }\n\n  .sec-seven .title {\n    width: 100%;\n    text-align: center;\n    font-size: 36px;\n    line-height: 42px;\n  }\n\n  .sec-seven .desc {\n    width: 100%;\n    text-align: center;\n  }\n\n  .sec-eight .sec-eight-wrap .inner {\n    flex-direction: column;\n  }\n\n  .sec-eight .sec-eight-wrap .inner .left {\n    width: 100%;\n  }\n\n  .sec-eight .sec-eight-wrap .inner .right {\n    width: 100%;\n  }\n\n  .sec-eight .right .p-c-wrapper {\n    flex-direction: column;\n  }\n\n  .sec-eight .right {\n    padding: 10px;\n  }\n\n  .sec-eight .sec10-container .sec10-list .sec10-title h3 {\n    color: #bababa;\n    font-family: \"Poppins\";\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin: 0;\n  }\n\n  .sec-nine {\n    padding-top: 30px;\n    overflow: hidden;\n  }\n\n  .sec-nine .desc {\n    width: 100%;\n    text-align: center;\n  }\n\n  .sec-nine .investor-card {\n    display: flex;\n    padding: 0px;\n    flex-direction: column;\n  }\n\n  .sec-nine .investor-card-body .bt1 {\n    margin-bottom: 0px;\n    width: 30px;\n  }\n\n  .sec-nine .investor-card-body .bt2 {\n    margin-top: 0px;\n    width: 30px;\n  }\n\n  .sec-nine .investor-card-body {\n    padding: 10px;\n  }\n\n  .sec-ten {\n    padding-top: 0px;\n    padding-inline: 0px;\n    overflow: hidden;\n  }\n\n  .sec-nine .investor-card .investor-card-img {\n    width: 200px;\n    height: 200px;\n  }\n\n  .sec-nine .investor-card .investor-card-img img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .sec-nine .slick-prev {\n    width: 50px;\n  }\n\n  .sec-nine .slick-next {\n    width: 50px;\n  }\n\n  .sec-eleven {\n    padding-top: 10px;\n    padding-bottom: 40px;\n  }\n\n  .sec-eleven form {\n    padding: 25px 15px;\n  }\n\n  .sec-eleven form .type .left p {\n    font-size: 10px;\n  }\n\n  .sec-eleven form .type .right p {\n    font-size: 10px;\n  }\n\n  .sec-seven .card-wrap {\n    background: #fff;\n    height: 100%;\n    padding: 15px 0px;\n    position: relative;\n  }\n\n  .open-header {\n    /* padding-right: 1em; */\n    padding-top: 1rem !important;\n  }\n\n  .sec-eight .sec-eight-wrap .inner .left .parent .parent-p {\n    padding: 10px 0px 10px 30px;\n  }\n\n  .sec-eight .sec-eight-wrap .inner .left .open-header-sub-menu li {\n    padding-left: 50px;\n  }\n\n  .sec-eight .sec-eight-wrap .inner .left {\n    background: #232323;\n    padding-bottom: 10px;\n  }\n\n  .sec-eleven form .row:nth-child(3) h3 {\n    margin-top: 20px;\n  }\n}\n\n@media (max-width: 1020px) {\n  .notification-card {\n    top: 60px;\n    right: 33px;\n    left: auto;\n  }\n\n  .not-top-icon {\n    right: 55px;\n  }\n\n  /* .not-top-main-icon {\n    right: 108px;\n  } */\n}\n\n@media (max-width: 500px) {\n  /* .not-top-main-icon {\n    right: 82px;\n  } */\n  .notification-card-main {\n    right: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
